import { Button, Col, Form, Input, Layout, Modal, Row, Space, Typography } from "antd";
import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";

import apiPath from "../../constants/apiPath";
import { AuthContext } from "../../context/AuthContext";
import { Severty, ShowToast } from "../../helper/toast";
import useRequest from "../../hooks/useRequest";
import signinbg from "../../assets/images/for-sojo-login-small-image.jpg";
import signinLogo from "../../assets/images/sojo_logo.jpeg";
  import GoogleImage from "../../assets/images/google_icons.svg";
  import LineImage from "../../assets/images/line_icons.svg";
const { Header, Content } = Layout;
const { Title } = Typography;


const Register = () => {
  const { setIsLoggedIn, setUserProfile } = useContext(AuthContext);
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const { request } = useRequest();
  const [loading, setLoading] = useState(false);
  const [isOtpModalVisible, setIsOtpModalVisible] = useState(false);
  const [otp, setOtp] = useState("");
  const [emailForOtp, setEmailForOtp] = useState("");
  const [resendLoading, setResendLoading] = useState(false);

  const onFinish = (values) => {
    const payload = {
      name: values.name,
      business_name: values.business_name,
      email: values.email,
      password: values.password,
    };

    setLoading(true);
    request({
      url: apiPath.signUp,
      method: "POST",
      data: payload,
      onSuccess: (data) => {
        setLoading(false);
        if (data.status || data.code === "OTP_SENT") {
          ShowToast("Please verify your email to continue", Severty.SUCCESS);
          setEmailForOtp(values.email);
          setIsOtpModalVisible(true);
        } else {
          ShowToast(data.message, Severty.ERROR);
        }
      },
      onError: (error) => {
        setLoading(false);
        ShowToast(error?.response?.data?.message, Severty.ERROR);
      },
    });
  };
  const handleVerifyOtp = () => {
    request({
      url: apiPath.verifyOTP,
      method: "POST",
      data: { email: emailForOtp, otp },
      onSuccess: (data) => {
        console.log("verifyOtp response:", data);

        if (data.statusText === "VERIFIED" && data.status === 200) {
          ShowToast("Account verified successfully!", Severty.SUCCESS);
          setIsOtpModalVisible(false);
          navigate("/login");
        } else {
          ShowToast(data.message || "OTP verification failed", Severty.ERROR);
        }
      },
      onError: (error) => {
    console.log("Full error:", error);

    const backendMessage =
      error?.response?.data?.error ||
      error?.response?.data?.message ||
      error?.message || // Axios default error
      "Something went wrong";

    setLoading(false);
    ShowToast(backendMessage, Severty.ERROR);
  },
    });
  };

  const handleResendOtp = () => {
    setResendLoading(true);
    request({
      url: apiPath.signUp,
      method: "POST",
      data: { email: emailForOtp, password: "dummy", name: "dummy" },
      onSuccess: (data) => {
        setResendLoading(false);
        if (data.status || data.code === "OTP_SENT") {
          ShowToast("OTP resent successfully!", Severty.SUCCESS);
        } else {
          ShowToast(data.message, Severty.ERROR);
        }
      },
      onError: (error) => {
        setResendLoading(false);
        ShowToast(
          error?.response?.data?.message || "Failed to resend OTP",
          Severty.ERROR
        );
      },
    });
  };

  return (
   <>
       <div className="main-new-login-page-designe-divv">
            <Layout className="layout-default layout-signin">
              <Content className="signin">
                <Row>
                  <Col span={24} lg={12} className="signin-bg d-none d-lg-block">
                    <div className="signin_img">
                      <img src={signinbg} alt="Signin background" />
                    </div>
                  </Col>
    
                  <Col span={24} lg={12} className="contant-bg-sign">
                    <div className="signin-box">
                      <div className="signup-logo">
                        <img src={signinLogo} alt="Signin logo" />
                      </div>
    
                      <Row justify="space-around">
                        <Col xs={{ span: 24 }} lg={{ span: 24 }} md={{ span: 24 }}>
                          <div className="signup-form">
                            <Title className="mb-15">Create Your Business Account</Title>
    
                          <Form
            form={form}
            onFinish={onFinish}
            layout="vertical"
            className="row-col"
          >
            {/* Business Name */}
            <Form.Item
              label="Business Name"
              name="business_name"
              normalize={(val) => val.trimStart()}
              rules={[
                { required: true, message: "Please enter business name!" },
              ]}
            >
              <Input placeholder="Enter Business Name" />
            </Form.Item>

            {/* Contact Name */}
            <Form.Item
              label="Contact Name"
              name="name"
              normalize={(val) => val.trimStart()}
              rules={[
                { required: true, message: "Please enter Contact name!" },
              ]}
            >
              <Input placeholder="Enter Contact Name" />
            </Form.Item>

            {/* Email */}
            <Form.Item
              label="Email Address"
              name="email"
              normalize={(val) => val.trimStart()}
              rules={[
                { type: "email", message: "Enter a valid email!" },
                { required: true, message: "Please enter your email!" },
              ]}
            >
              <Input placeholder="Enter Email Address" />
            </Form.Item>

            {/* Password */}
            <Form.Item
              label="Password"
              name="password"
              normalize={(val) => val.trimStart()}
              rules={[
                {
                  pattern: new RegExp(
                    /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*]).{8,}$/
                  ),
                  message:
                    "Password must have 8+ characters, uppercase, lowercase, number, special char",
                },
                { required: true, message: "Please enter your password!" },
              ]}
            >
              <Input.Password
                placeholder="Create Password"
                autoComplete="off"
              />
            </Form.Item>

            {/* Confirm Password */}
            <Form.Item
              label="Confirm Password"
              name="confirm_password"
              dependencies={["password"]}
              normalize={(val) => val.trimStart()}
              hasFeedback
              rules={[
                { required: true, message: "Please confirm your password!" },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("password") === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error("Passwords do not match!"));
                  },
                }),
              ]}
            >
              <Input.Password
                placeholder="Confirm Password"
                autoComplete="off"
              />
            </Form.Item>

            {/* Submit */}
            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                loading={loading}
                className="w-100"
              >
                Sign Up
              </Button>
            </Form.Item>

            {/* Social Login */}
            <div className="social-iconmain">
           
                <span
                  onClick={() => (window.location.href = apiPath.social.google)}
                >
                 <img src={GoogleImage} />
                </span>
                <span
                  onClick={() => (window.location.href = apiPath.social.line)}
                >
                 <img src={LineImage} />
                </span>
           
            </div>

            <div className="dont-have-account-main">
              Already have an account? 
              <span onClick={() => navigate("/login")}>
                Login
              </span>
            </div>
          </Form>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </Col>
                </Row>
              </Content>
    
          
            </Layout>
          </div>
    
   

      <Modal
        title="Verify Your Email"
        open={isOtpModalVisible}
        onCancel={() => setIsOtpModalVisible(false)}
        footer={null}
      >
        <p>We sent an OTP to {emailForOtp}. Please enter it below:</p>
        <Input
          placeholder="Enter OTP"
          value={otp}
          onChange={(e) => setOtp(e.target.value)}
          maxLength={6}
          style={{ marginBottom: 12 }}
        />
        <Button type="primary" onClick={handleVerifyOtp} block>
          Verify
        </Button>
        <Button
          type="link"
          onClick={handleResendOtp}
          loading={resendLoading}
          block
          style={{ marginTop: 8 }}
        >
          Resend OTP
        </Button>
      </Modal>
   </>
 
  );
};

export default Register;
